import Network from 'infrastructure/js/modules/network';
import * as formActionsHelper from '../../Forms/formActionsHelper';
import { api as messageDialogApi } from '../../MessageDialog/messageDialogActions.js';
import * as qplsService from '../../../services/Qpls/qplsService.js';
import { formsNames } from '../../../enums/formsNames';
import { getResponseValidationDetails } from 'infrastructure/js/components/Form/formHelper';
import {FormModes} from '../../../components/Administration/MatSettingsPage/utils/qplHelper';
import {enumTypes, getEnumValue} from '../../../utils/enumHelper';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import { api as createQplTestFieldDialogApi } from '../MatSettingsPage/Dialogs/createQplTestFieldDialogActions';
import {api as exportApi} from '../../Export/exportActions';
import {dialogsNames} from '../../../enums/dialogsNames';

const config = {
  getSubmitMethod: () => null, //set null when override the formActionsHelper's submit() method
};

export const actionTypes = {
  ...formActionsHelper.getActionTypes(formsNames.QPL_TEST_FORM),
  QPL_TEST_FORM_FETCH_OPTIONAL_FIELDS_READY: 'QPL_TEST_FORM_FETCH_OPTIONAL_FIELDS_READY',
};

const actions = {
  ...formActionsHelper.getActions(formsNames.QPL_TEST_FORM),

  fetchOptionalFieldsReady(payload) {
    return { type: actionTypes.QPL_TEST_FORM_FETCH_OPTIONAL_FIELDS_READY, payload };
  },
};

export let api = {
  ...formActionsHelper.getApiActions(actions, config),


  fetchFormItem(dispatch, getState) {
    return function (qplTestId, qplId) {
      dispatch(actions.setBusy(true));

      return qplsService.getQplTestDetails(qplTestId).then(response => {
        dispatch(actions.setBusy(false));

        if (!Network.isResponseValid(response)) {
          console.error('fetch qpl test details failed', response);
          messageDialogApi.responseError(dispatch, getState)(response);
          return null;
        }
        if (!response.data) {  //should never get here
          console.error('qpl test not found', response);
          messageDialogApi.showError(dispatch, getState)();
          return null;
        }
        return response?.data;
      })
    }
  },

  fetchFormData(dispatch, getState) {
    return function () {
      dispatch(actions.setBusy(true));

      let promise1 = qplsService.getQplTestMandatoryFields({testType: getEnumValue(enumTypes.TEST_TYPE)('QUANTITATIVE')})
      let promise2 = qplsService.getQplTestMandatoryFields({testType: getEnumValue(enumTypes.TEST_TYPE)('QUALITY')})
      let promise3 = qplsService.getAllDescriptions();
      let promise4 = qplsService.getQplTestOptionalFields({testType: getEnumValue(enumTypes.TEST_TYPE)('QUANTITATIVE')});
      let promise5 = qplsService.getQplTestOptionalFields({testType: getEnumValue(enumTypes.TEST_TYPE)('QUALITY')});

      return Promise.all([promise1, promise2, promise3, promise4, promise5]).then((allResults) => {
        const invalidResponse = allResults.find(response => {
          return !Network.isResponseValid(response);
        });

        if (invalidResponse){
          console.error('Fetch QPL test fields failed', invalidResponse);
          messageDialogApi.responseError(dispatch, getState)(invalidResponse);
          return {success: false};
        }

        const labels = createLabelHelper('');

        let quantityFields = allResults[0]?.dataList?.filter(item => item.defaultFieldOrder)
                                       .sort((op1, op2) => {return op1.defaultFieldOrder < op2.defaultFieldOrder ? -1 : 1});
        let qualityFields = allResults[1]?.dataList?.filter(item => item.defaultFieldOrder)
                                       .sort((op1, op2) => {return op1.defaultFieldOrder < op2.defaultFieldOrder ? -1 : 1});
        let codeNameFields = allResults[2]?.dataList?.map(item => {return {value: item.id, label: item.codeName, data: item} }) ?? [];

        let quantityOptionalFields = allResults[3]?.dataList?.map(item => {return { value: item.id,
                                                                                            label: item.custom ? item.displayName : labels.get(item.labelKey),
                                                                                            data: item} } ) ?? [];
        let qualityOptionalFields = allResults[4]?.dataList?.map(item => {return {  value: item.id,
                                                                                            label: item.custom ? item.displayName : labels.get(item.labelKey),
                                                                                            data: item} }) ?? [];

        let formData = { quantityFields, qualityFields, codeNameFields, quantityOptionalFields, qualityOptionalFields };

        dispatch(actions.fetchFormDataReady(formData));
        dispatch(actions.setBusy(false));

        return { success: true };
      });
    };
  },

  fetchOptionalFields(dispatch, getState) {
    return function () {
      dispatch(actions.setBusy(true));

      let promise1 = qplsService.getQplTestOptionalFields({testType: getEnumValue(enumTypes.TEST_TYPE)('QUANTITATIVE')});
      let promise2 = qplsService.getQplTestOptionalFields({testType: getEnumValue(enumTypes.TEST_TYPE)('QUALITY')});

      return Promise.all([promise1, promise2]).then((allResults) => {
        const invalidResponse = allResults.find(response => {
          return !Network.isResponseValid(response);
        });

        if (invalidResponse){
          console.error('Fetch optional QPL test fields failed', invalidResponse);
          messageDialogApi.responseError(dispatch, getState)(invalidResponse);
          return {success: false};
        }

        const labels = createLabelHelper('');

        let quantityOptionalFields = allResults[0]?.dataList?.map(item => {return { value: item.id,
                                                                                            label: item.custom ? item.displayName : labels.get(item.labelKey),
                                                                                            data: item} } ) ?? [];
        let qualityOptionalFields = allResults[1]?.dataList?.map(item => {return {  value: item.id,
                                                                                            label: item.custom ? item.displayName : labels.get(item.labelKey),
                                                                                            data: item} }) ?? [];

        let formData = { quantityOptionalFields, qualityOptionalFields };

        dispatch(actions.fetchOptionalFieldsReady(formData));
        dispatch(actions.setBusy(false));

        return { success: true };
      });
    };
  },


  submit(dispatch, getState) {
    return function (data, formMode, callback) {
      dispatch(actions.setBusy(true));

      let method = _getMethodByMode(formMode);
      method?.(data).then((response) => {
        dispatch(actions.setBusy(false));

        let validations = getResponseValidationDetails(response);
        if (validations) {
          dispatch(actions.setValidationWarningsData(validations));
          return { success: false };
        }

        if (!Network.isResponseValid(response)) {
          console.error('Create/Edit QPL test failed', response);
          messageDialogApi.responseError(dispatch, getState)(response);
          return { success: false };
        }

        callback?.(response?.data);

        return { success: true };
      });
    };
  },

};

export let jsxActions = {
  ...formActionsHelper.getJsxActions(api),

  fetchFormItem(qplTestId, qplId) {
    return function (dispatch, getState) {
      return api.fetchFormItem(dispatch, getState)(qplTestId, qplId);
    };
  },

  submit(data, formMode, callback) {
    return function (dispatch, getState) {
      return api.submit(dispatch, getState)(data, formMode, callback);
    };
  },

  onCreateNewField() {
    return function (dispatch, getState) {
      return createQplTestFieldDialogApi.show(dispatch, getState)({activeDialog: dialogsNames.CREATE_QPL_TEST_FIELD_DIALOG});
    };
  },

  fetchOptionalFields() {
    return function (dispatch, getState) {
      return api.fetchOptionalFields(dispatch, getState)();
    };
  },

  exportToPdf(data) {
    return function(dispatch, getState) {
      exportApi.exportToPdf(dispatch, getState)(data);
    }
  }

};

/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS

function _getMethodByMode(formMode) {
  switch (formMode) {
    case FormModes.CREATE:
      return qplsService.createQplTest;
    case FormModes.EDIT:
      return qplsService.editQplTest;
    case FormModes.CLONE:
      return qplsService.cloneQplTest;
    default:
      console.error('Unknown form mode:', formMode);
      return null;
  }
}
